module.exports = __webpack_public_path__ + "static/media/play-background-1.72b1079e.jpg";